import { render, staticRenderFns } from "./bsp-empty.vue?vue&type=template&id=08c50df3&scoped=true&"
import script from "./bsp-empty.vue?vue&type=script&lang=js&"
export * from "./bsp-empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c50df3",
  null
  
)

export default component.exports